export default __webpack_public_path__ + "static/media/pythonfront.fcc32338.svg";